import { configurationApi } from '../configurationApi';
import { CenterType } from '../types/centerType';
import { GetCenterRequest } from '../requests/getCenterRequest';
import { ConfigureSurgeryBoardConflictsRequest } from '../requests/configureSurgeryBoardConflictsRequest';

const centerEndpoints = configurationApi.injectEndpoints({
  endpoints: (builder) => ({
    getCenters: builder.query<CenterType[], { company: string }>({
      query: ({ company }) => `/centers?company=${encodeURIComponent(company)}`,
      providesTags: ['Centers'],
    }),

    getCenter: builder.query<CenterType, GetCenterRequest>({
      query: ({ id, company }) =>
        `/center?id=${encodeURIComponent(id)}&company=${encodeURIComponent(company)}`,
      providesTags: (result, error, { id }) => [{ type: 'Center', id }],
    }),

    updateCenter: builder.mutation<CenterType, CenterType>({
      query: (center) => ({
        url: '/center',
        method: 'POST',
        body: center,
      }),
      invalidatesTags: ['Centers', 'Center'],
    }),

    // Writes only the board's AppConfig fields. The surgery board reads them through Encounters, so the
    // caller refreshes the board itself.
    configureSurgeryBoardConflicts: builder.mutation<CenterType['appConfig'], ConfigureSurgeryBoardConflictsRequest>({
      query: (body) => ({
        url: '/ConfigureSurgeryBoardConflicts',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Centers', 'Center'],
    }),

    getCenterTypes: builder.query<{ name: string; value: string }[], void>({
      query: () => '/CenterTypes',
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetCentersQuery,
  useGetCenterQuery,
  useUpdateCenterMutation,
  useConfigureSurgeryBoardConflictsMutation,
  useGetCenterTypesQuery,
} = centerEndpoints;
